<template>
  <div class="auth-process-container" id="login-process-container">
    <div class="auth-process" id="login-process">
      <q-card bordered flat class="auth-process-card" id="login-process-card">
        <img id="login-logo" :src="require('../assets/brands/logo.png')" alt=""/>
        <loading v-if="isLoading" id="loading"></loading>
        <form @submit.prevent="onSubmit" class="q-gutter-y-xs" id="login-form" v-else>
          <q-input
              ref="email"
              label-color="grey-7"
              outlined
              color="grey-7"
              v-model="email"
              label="Email*"
              lazy-rules
              type="email"
              :loading="loading"
              :rules="[isValidEmail]"
          >
            <template v-slot:prepend>
              <q-icon id="login-envelope-icon" size="16px" color="grey-7" name="far fa-envelope"/>
            </template>
          </q-input>
          <q-input
              ref="password"
              type="password"
              outlined
              color="grey-7"
              label-color="grey-7"
              v-model="password"
              label="Password*"
              lazy-rules
              :loading="loading"
              :rules="[val => (val !== null && val !== '') || 'Please type your password']"
          >
            <template v-slot:prepend>
              <q-icon id="login-lock-icon" size="16px" color="grey-7" name="fas fa-lock"></q-icon>
            </template>
          </q-input>
          <q-checkbox id="login-input-remember" color="grey-7" v-model="remember" dense>
            <template>
              <div id="login-remember-text" style="color:#bdbdbd">
                Remember Me
              </div>
            </template>
          </q-checkbox>
          <div id="login-other-things" class="other-things">
            <!-- <span @click="$router.push({name:'register'})">Create Account</span> -->
            <span id="login-forgot-text" @click="$router.push({ name: 'forgotPassword' })">Forgot Password?</span>
            <span id="login-demo-text" @click="$router.push({ name: 'free-trial' })">Sign Up for Free Account</span>
          </div>
          <div id="login-process-actions" class="flex justify-between full-width" style="margin-top: 15px;">
            <div class="flex justify-start" v-if="Object.keys(providers).length > 0">
              <q-btn type="button"
                     color="red"
                     style="margin-right: 10px;"
                     @click="linkAccount('google')"
                     v-if="'google' in providers">
                <template v-slot:default>
                  <q-tooltip>Login with Google</q-tooltip>
                  <i class="fab fa-google"></i>
                </template>
              </q-btn>
              <q-btn type="button"
                     color="blue"
                     style="margin-right: 10px; background-color: #014a88 !important;"
                     @click="linkAccount('linkedin')"
                     v-if="'linkedin' in providers">
                <template v-slot:default>
                  <q-tooltip>Login with LinkedIn</q-tooltip>
                  <i class="fab fa-linkedin"></i>
                </template>
              </q-btn>
              <q-btn type="button"
                     color="blue"
                     @click="linkAccount('facebook')"
                     v-if="'facebook' in providers">
                <template v-slot:default>
                  <q-tooltip>Login with Facebook</q-tooltip>
                  <i class="fab fa-facebook"></i>
                </template>
              </q-btn>
            </div>
            <q-btn :loading="loading" label="Login" type="submit" color="positive" id="login-button">
              <template v-slot:loading>
                <q-spinner-facebook/>
              </template>
            </q-btn>
          </div>
        </form>
      </q-card>
    </div>
  </div>
</template>

<script>
import axios from '../axios'
import isValidEmail from '../helper/emailValidation'
import Loading from "@/components/Loading.vue";

export default {
  name: 'login',
  components: {Loading},
  data() {
    return {
      remember: JSON.parse(localStorage.getItem('__remember')) || false,
      email: localStorage.getItem('__email') || '',
      password: localStorage.getItem('__pass') ? atob(localStorage.getItem('__pass')) : '',
      loading: false,
      isLoading: false,
      providers: {}
    }
  },
  methods: {
    isValidEmail,
    resetForm() {
      this.email = ''
      this.password = ''
      this.$refs.email.resetValidation()
      this.$refs.password.resetValidation()
    },

    isRemember() {
      if (this.remember) {
        localStorage.setItem('__remember', JSON.stringify(true))
        localStorage.setItem('__email', this.email)
        localStorage.setItem('__pass', btoa(this.password))
      } else {
        localStorage.removeItem('__remember')
        localStorage.removeItem('__email')
        localStorage.removeItem('__pass')
      }
    },
    onSubmit() {
      const payload = {
        username: this.email,
        password: this.password,
        remember_me: true
      }
      this.loading = true
      axios
          .post(`/auth/login`, payload)
          .then(({data}) => {
            this.loading = false
            localStorage.setItem('token', `Bearer ${data.data.token}`)
            this.isRemember()
            this.$q.notify({
              message: 'Login success.Please wait for redirect.',
              timeout: 250,
              position: 'top-right',
              progress: true,
              type: 'positive'
            })
            this.$router.push('/')
          })
          .catch(err => {
            this.loading = false
            this.remember = false
            this.resetForm()
            const {message} = err.response.data
            this.$q.notify({
              message,
              timeout: 2000,
              position: 'top-right',
              progress: true,
              type: 'negative'
            })
          })
    },
    async linkAccount(service) {
      const serviceUrl = this.providers[service] || null;
      console.log(this.providers)
      if (serviceUrl) {
        window.location.href = serviceUrl;
      }
    },
  },
  async mounted() {
    const emailRef = this.$refs.email
    const inputRef = emailRef.$refs.input
    inputRef.id = 'login-input-email'

    const passwordRef = this.$refs.password
    const inputPassRef = passwordRef.$refs.input
    inputPassRef.id = 'login-input-password'

    try {
      this.isLoading = true;
      const {data} = await axios.get(`/auth/oauth2?redirect_path=/`);
      this.providers = data.data;
    } catch (error) {
      console.error(error);
    } finally {
      this.isLoading = false;
    }
  },
  metaInfo() {
    return {
      title: 'Welcome to Fleet Management System | FMS',
      meta: [
        {
          name: 'description',
          // "FMS is about connecting in your field of interest. Our vision is to help people share their knowledge, work, projects, papers and ideas and build their network through what they do rather where they live, study or work.",
          content: ''
        },
        {
          property: 'og:title',
          content: 'Welcome to Fleet Management System | FMS'
        },
        {property: 'og:site_name', content: 'FMS'},
        {property: 'og:type', content: 'website'},
        {name: 'robots', content: 'index,follow'}
      ]
    }
  }
}
</script>

<style scoped>
.special-component {
  width: 100%;
  background-color: #fff;
}
</style>
